import Layout from '@/layout/index.vue';

export default [
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          icon: 'ant-design:bank-outlined',
          title: '首页',
          newPage: true,
          affixTagView: true,
          noCache: true
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: "登陆",
      noCache: true
    },
  },
]